import { createEventBus } from "~/utils/miscellaneous";

export default function (app) {
  const eventBus = createEventBus();

  app.eventBus = eventBus;
  app.config.globalProperties.eventBus = eventBus;
  app.provide("eventBus", eventBus);
}
